import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Body1, Body2, Caption1, Dot, Link as ExternalLink } from "@activecollab/components";
import moment from "moment-timezone";
import PropTypes from "prop-types";
import FormatDate from "~/components/Formatters/FormatDate";

const NewFeatureItem = ({ feature }) => {
  const { t } = useTranslation();
  return (
    <div className="tw-flex tw-py-2">
      <div className="tw-flex tw-items-center tw-justify-end sm:tw-w-32 tw-h-6 tw-gap-3 tw-px-3 tw-shrink-0">
        <Caption1
          letterSpacing="regular"
          color="secondary"
        >
          <FormatDate value={moment(feature.date).unix()} />
        </Caption1>
        <Dot
          size={4}
          color="#89898E"
        />
      </div>
      <div className="tw-flex tw-flex-col tw-gap-2 tw-max-w-[640px] tw-w-full">
        <div className="tw-flex tw-items-center tw-gap-2">
          <Body1
            weight="bold"
            letterSpacing="regular"
          >
            {feature.title}
          </Body1>
          {!feature.is_seen ? (
            <span className="tw-bg-[#FBBB75] tw-uppercase tw-rounded-full tw-px-3 tw-h-[18px] tw-flex tw-items-center tw-text-xxs tw-font-medium tw-text-black">
              {t("new")}
            </span>
          ) : null}
        </div>

        <Body2
          letterSpacing="regular"
          color="secondary"
        >
          {feature.description}
        </Body2>
        {feature.action_url?.includes("http") ? (
          <ExternalLink
            variant="text link-primary"
            className="tw-block tw-no-underline tw-font-normal tw-outline-none"
            href={feature.action_url}
            target="_blank"
          >
            {feature.action_title}
          </ExternalLink>
        ) : (
          <Link
            className="activity-link tw-no-underline tw-outline-none"
            to={`/${feature.action_url}`}
          >
            {feature.action_title}
          </Link>
        )}
      </div>
    </div>
  );
};

NewFeatureItem.propTypes = {
  feature: PropTypes.object,
};

NewFeatureItem.displayName = "NewFeatureItem";

export default NewFeatureItem;
